import { render } from "./PackageDetail.vue?vue&type=template&id=b6ea1822&scoped=true"
import script from "./PackageDetail.vue?vue&type=script&lang=js"
export * from "./PackageDetail.vue?vue&type=script&lang=js"

import "./PackageDetail.vue?vue&type=style&index=0&id=b6ea1822&scoped=true&lang=css"

import exportComponent from "/Users/fikri/Work/PRiADI/code/priadi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ea1822"]])

export default __exports__